const FalsificatGridPluginSettings: IPluginSettings = {
    name: 'Фальсификаты',
    mnemocode: 'falsificat_plugin',
    permission: 'Falsificat',
    columns: [{
        order: 0,
        propertyName: 'idGlobal',
        propertyType: 'string',
        displayName: 'ИД',
        visibility: false,
        width: 150
    }, 
    {
        order: 1,
        propertyName: 'type',
        propertyType: 'string',
        displayName: 'Тип',
        visibility: false,
        width: 150
    },
    {
        order: 2,
        propertyName: 'goodsName',
        propertyType: 'string',
        displayName: 'Препарат',
        visibility: true,
        width: 150
    },
    {
        order: 3,
        propertyName: 'producerName',
        propertyType: 'string',
        displayName: 'Производитель',
        visibility: true,
        width: 150
    },
    {
        order: 4,
        propertyName: 'seria',
        propertyType: 'string',
        displayName: 'Серия поставщика',
        visibility: true,
        width: 150
    },
    {
        order: 5,
        propertyName: 'labName',
        propertyType: 'string',
        displayName: 'Лаборатория',
        visibility: true,
        width: 150
    },
    {
        order: 6,
        propertyName: 'regionName',
        propertyType: 'string',
        displayName: 'Регион',
        visibility: true,
        width: 150
    },
    {
        order: 7,
        propertyName: 'supplierName',
        propertyType: 'string',
        displayName: 'Поставщик',
        visibility: true,
        width: 150
    },
    {
        order: 8,
        propertyName: 'documentDate',
        propertyType: 'datetime',
        displayName: 'Дата документа',
        visibility: true,
        width: 150
    },
    {
        order: 9,
        propertyName: 'documentNum',
        propertyType: 'string',
        displayName: 'Номер документа',
        visibility: true,
        width: 150
    },
    {
        order: 10,
        propertyName: 'dateModified',
        propertyType: 'datetime',
        displayName: 'Дата изменения',
        visibility: true,
        width: 150
    },
    {
        order: 11,
        propertyName: 'dateDeleted',
        propertyType: 'datetime',
        displayName: 'Дата удаления',
        visibility: true,
        width: 150
    },
    {
        order: 12,
        propertyName: 'dateCreated',
        propertyType: 'datetime',
        displayName: 'Дата создания',
        visibility: true,
        width: 150
    },
    {
        order: 13,
        propertyName: 'deleted',
        propertyType: 'boolean',
        displayName: 'Удален',
        visibility: true,
        width: 150
    }]
}

export default FalsificatGridPluginSettings